class SlideBackgroundVideo {
  constructor(selector = '.slide-background-video') {
    this.items = Array.from(document.querySelectorAll(selector));
    if (!this.items.length) return;
    this.init();
  }

  init() {
    this.items.forEach((container) => this.setupContainer(container));
  }

  setupContainer(container) {
    const video = container.querySelector('video');
    if (!video) return;

    // Create play button overlay if not present
    let playBtn = container.querySelector('.slide-background-video__play');
    if (!playBtn) {
      playBtn = document.createElement('button');
      playBtn.type = 'button';
      playBtn.className = 'slide-background-video__play';
      playBtn.setAttribute('aria-label', 'Play video');
      container.appendChild(playBtn);
    }

    const play = () => {
      // Auto-mute to avoid unexpected audio
      video.muted = true;
      video.play();
      playBtn.classList.add('is-hidden');
    };

    const pause = () => {
      video.pause();
      video.currentTime = 0;
      playBtn.classList.remove('is-hidden');
    };

    container.addEventListener('mouseenter', play);
    container.addEventListener('mouseleave', pause);
    playBtn.addEventListener('click', (e) => {
      e.preventDefault();
      play();
    });
  }
}

export default SlideBackgroundVideo;

